'use strict';

const { h, Component } = require('phy');
const { hydrate } = require('@grpn/hydration');
const { Translate } = require('@grpn/preact-l10n');

const { publish } = require('../../support/event-observer');
const getUniqueArrayFromObjects = require('../../support/get-unique-array-from-objects');

class CouponsFilter extends Component {
  constructor(props, ...rest) {
    super(props, ...rest);
  }
  render({ coupons }) {
    const offerTypes = getUniqueArrayFromObjects(coupons, c => c.offerType);

    return h('.coupons-filter', [
      h('ul.coupons-filter-list', [
        h('li.coupons-filter-item', [
          h('input.coupons-filter-input', {
            id: `coupons-filter-all`,
            type: 'radio',
            name: 'group',
            checked: true,
            onChange: this.changeHandlerFilter(null),
          }),
          h(
            'label.coupons-filter-label',
            {
              for: `coupons-filter-all`,
              tabindex: 0,
              onKeyUp: this.keyUpHandlerFilter,
            },
            h(Translate, 'js.modules.shared.AllFilter')
          ),
        ]),
        ...offerTypes.map((type, index) =>
          h('li.coupons-filter-item', [
            h('input.coupons-filter-input', {
              id: `coupons-filter-${index}`,
              type: 'radio',
              name: 'group',
              onChange: this.changeHandlerFilter(type),
            }),
            h(
              'label.coupons-filter-label',
              {
                for: `coupons-filter-${index}`,
                tabindex: 0,
                onKeyUp: this.keyUpHandlerFilter,
              },
              h(Translate, this.getLabelResourceKey(type))
            ),
          ])
        ),
      ]),
    ]);
  }

  keyUpHandlerFilter(ev) {
    if (ev.keyCode === 13) {
      ev.target.click();
    }
  }

  getLabelResourceKey(type) {
    const key = type.replace(/Online|Instore/, '');

    return `js.modules.shared.OfferTypeFilter.${key}`;
  }

  changeHandlerFilter(offerType) {
    return () => publish('@filter', { offerType });
  }
}

module.exports = hydrate('CouponsFilter', CouponsFilter);
